import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Data transformer function remains the same
export const transformDataForPieChart = (data, key) => {
    const labels = Object.keys(data);
    const values = labels.map(city => parseFloat(data[city][key] || 0));
    const counts = labels.map(city => parseInt(data[city][key.replace('amount', 'count')] || 0));

    return {
        labels,
        values,
        counts
    };
};

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ data, selectedKey }) => {
    const transformedData = transformDataForPieChart(data, selectedKey);

    // Predefined bright colors array
    const brightColors = [
        '#FF6B6B', // Bright Red
        '#4ECDC4', // Turquoise
        '#45B7D1', // Sky Blue
        '#96CEB4', // Mint
        '#FFEEAD', // Cream Yellow
        '#D4A5A5', // Dusty Rose
        '#9B59B6', // Purple
        '#3498DB', // Blue
        '#E67E22', // Orange
        '#2ECC71', // Emerald Green
        '#F1C40F', // Yellow
        '#FF7979', // Coral
        '#786FA6', // Twilight Purple
        '#7ED6DF', // Electric Blue
        '#F8A5C2'  // Pink
    ];

    // Function to get colors based on data length
    const getColors = (count) => {
        // If we need more colors than we have, we'll start repeating from the beginning
        let colors = [];
        for (let i = 0; i < count; i++) {
            colors.push(brightColors[i % brightColors.length]);
        }
        return colors;
    };

    const backgroundColor = getColors(transformedData.labels.length);

    const chartData = {
        labels: transformedData.labels,
        datasets: [
            {
                data: transformedData.values,
                backgroundColor,
                borderColor: backgroundColor, // Same colors for borders
                borderWidth: 2,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 8,
                    padding: 8,
                    font: {
                        size: 10
                    }
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const label = context.label || '';
                        const value = context.raw;
                        const count = transformedData.counts[context.dataIndex];

                        let formattedValue;
                        if (value >= 10000000) formattedValue = `${(value / 10000000).toFixed(1)} Cr`;
                        else if (value >= 100000) formattedValue = `${(value / 100000).toFixed(1)} L`;
                        else if (value >= 1000) formattedValue = `${(value / 1000).toFixed(1)} K`;
                        else formattedValue = value.toFixed(2);

                        const title = selectedKey.replace('_amount', '').charAt(0).toUpperCase() +
                            selectedKey.replace('_amount', '').slice(1);

                        return `${label}: ${title} ${formattedValue} | Count: ${count}`;
                    },
                },
            },
        },
    };

    return (
        <div style={{ height: '14rem', width: '100%' }}>
            <Pie data={chartData} options={options} />
        </div>
    );
};

export default PieChart;